import React, { useRef } from "react";
import * as ReactDOMServer from "react-dom/server";
import { OrgChart } from "d3-org-chart";
import * as d3 from "d3";
import { useEffect, useState } from "react";
import { useGetOfficeHierarchyChart } from "../../../hooks/useGetOfficeHierarchyChart";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useHistory } from "react-router";
import { permissionsSelector } from "../../../../../Login/selectors/permissionSelector";
import { mainSelectedTab } from "../../../../atoms";
import { OfficeTabs } from "../../../../../OfficeTab/OfficeTabs";
import OHSalesOrgChartButton from "./OHSalesOrgChartButton";
import OHSalesOrgChartNode from "./OHSalesOrgChartNode";
import {
  dataId,
  officeHierarchyOnShowState,
  onClickSalesFullPage,
  onClickNsaFullPage,
  onClickSplcFullPage,
  empHierarchyState,
  setOfficeHierarchyRowForEdit,
  officeHierarchyModalState,
} from "../../../atoms/atoms";
import ConfirmBoxDelete from "../../../../../../components/ConfirmBoxDelete";
import { useQueryClient } from "react-query";
import useSendEmail from "../../../hooks/useSendEmail";
import useDeleteOfficeHierarchy from "../../../hooks/useDeleteOfficeHierarchy";
import { toast } from "../../../../../../components/toastNotification";
import { PERMISSIONS } from "../../../../../PermissionsConstants";
import {
  ArrowDownCircleIcon,
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
  MinusCircleIcon,
  PlusCircleIcon,
} from "@heroicons/react/24/outline";
import jsPDF from "jspdf";
import axios from "axios";

const OHSalesOrgChart = () => {
  //Org Chart Data
  const { data: ohChart } = useGetOfficeHierarchyChart();
  const [dataChart, setDataChart] = useState();
  //For Deactivate
  const {
    mutate: deactivateHierarchyChart,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeleteOfficeHierarchy();

  const history = useHistory();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [, setShowState] = useRecoilState(officeHierarchyOnShowState);
  const [, setOHIdData] = useRecoilState(dataId);
  const [, setIsParent] = useState(false);
  const [, setViewSalesData] = useRecoilState(onClickSalesFullPage);
  const [, setViewNsaData] = useRecoilState(onClickNsaFullPage);
  const [, setViewSplcData] = useRecoilState(onClickSplcFullPage);
  const [, setEditState] = useRecoilState(empHierarchyState);
  const [officeHierarchyId, setOfficeHierarchyId] = useState(0);
  const setRowToEdit = useSetRecoilState(setOfficeHierarchyRowForEdit);
  const [, setShowOfficeHierarchyModalState] = useRecoilState(
    officeHierarchyModalState
  );
  const [salesChartData, setSalesChartData] = useState();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [associatedActive, setAssociatedActive] = useState(false);
  const [compactChart, setCompactChart] = useState(false);
  const queryClient = useQueryClient();

  //Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  //Permission
  const deletePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_delete;
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_edit;

  useEffect(() => {
    setDataChart(ohChart?.data[1]?.officeHierarchySalesOrg);
  }, [ohChart?.data]);

  const d3Container = useRef(null);
  const chartRef = useRef(null);
  const containerStyles = {
    width: "100%",
    height: "100%",
  };

  const [cardShow, setCardShow] = useState(false);
  const [isClickedEllipsis, setIsClickedEllipsis] = useState(false);
  const handleShow = () => {
    setIsClickedEllipsis(true);
    setCardShow(true);
  };
  const handleClose = () => {
    setIsClickedEllipsis(false);
    setCardShow(false);
  };

  const [isDownloading, setIsDownloading] = useState(false);
  const api_base_url = process.env.REACT_APP_API_BASEURL;

  //Redirection to employee for territory to area
  const toEmployee = (d) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        employeeId: d.data.employeeId,
        action: "SalesOrgChart",
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
    localStorage.setItem("path", "/officesettings/officehierarchy");
  };

  const onClickOfficeHierarchyName = (rowData, isParent = false) => {
    setShowState(true);
    setOHIdData(rowData?.data.officeHierarchyId);
    setIsParent(isParent);
    setViewSalesData(true);
    setViewNsaData(false);
    setViewSplcData(false);
    history.push("/officesettings/officehierarchy");
    localStorage.setItem("ohIdRedirect", rowData?.data?.officeHierarchyId);
    localStorage.setItem("path", "/officesettings/officehierarchy");
  };

  //For Edit
  const handleEdit = () => {
    setRowToEdit({
      ...salesChartData,
      idC: salesChartData.id_c ? salesChartData.id_c : "",
      name: salesChartData.name ? salesChartData.name : "",
      type: salesChartData.type ? salesChartData.type : null,
      owner: salesChartData.createdBy ? salesChartData.createdBy : "",
      parentHierarchyId: salesChartData.parentHierarchyId
        ? Number(salesChartData.parentHierarchyId)
        : "",
      managerEmployeeId: salesChartData.employeeId
        ? salesChartData.employeeId
        : null,
      managerEffectiveDate:
        salesChartData?.managerEffectiveDate !== null
          ? new Date(salesChartData.managerEffectiveDate)
              .toISOString()
              .split("T")[0]
          : salesChartData?.managerEffectiveDate,
      isActive: salesChartData?.isActive ? true : false,
      code: salesChartData.code ? salesChartData.code : "",
    });
    setShowOfficeHierarchyModalState(true);
  };

  //For Deactivate
  const deactivateHierarchy = () => {
    if (associatedActive === true) {
      setOpenModalDelete(false);
      setAssociatedActive(false);
    } else {
      deactivateHierarchyChart(officeHierarchyId);
      setOpenModalDelete(false);
    }
  };

  const { mutateAsync: sendEmail } = useSendEmail();

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Office Hierarchy were deactivated successfully",
        "success"
      );
      deacResult.data.forEach((item) => {
        sendEmail(item);
      });
      queryClient.invalidateQueries("GetOfficeHierarchyChart");
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Office Hierarchy were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Deactivation of Office Hierarchy failed",
          "Server Error: Cannot deactivate Office Hierarchy",
          "error"
        );
      }

      queryClient.invalidateQueries("GetOfficeHierarchyChart");
    } else {
      toast.fire(
        "Deactivation of Office Hierarchy failed",
        "Server Error: Cannot deactivate Office Hierarchy",
        "error"
      );
      queryClient.invalidateQueries("GetOfficeHierarchyChart");
    }
    resetDeacData();
  }

  useEffect(() => {
    if (salesChartData) {
      //Filter territory hierarchy
      const validateAssociatedTerritory = dataChart?.filter(
        (x) =>
          salesChartData.territoryId !== 0 &&
          (x.territoryId === salesChartData.territoryId ||
            x.areaTerritoryId === salesChartData.territoryId ||
            x.officeHierarchyTerritoryId === salesChartData.id) &&
          x.id !== salesChartData.id
      );

      //Filter Area hierarchy
      const validateAssociatedArea = dataChart?.filter(
        (x) =>
          salesChartData.areaId !== 0 &&
          (x.areaId === salesChartData.areaId ||
            x.territoryId === salesChartData.areaTerritoryId ||
            x.officeHierarchyAreaId === salesChartData.id) &&
          x.id !== salesChartData.id
      );

      //Filter active hierarchies and open associated offices
      const validateActiveAssociatedOffice =
        validateAssociatedTerritory?.length > 0
          ? validateAssociatedTerritory.filter(
              (x) =>
                x.isActive === true ||
                (x.associatedOffices && x.associatedOffices?.length > 1) ||
                (x.associatedOffices &&
                  x.associatedOffices?.length === 1 &&
                  !x.associatedOffices[0]?.officeStatusName.includes("Closed"))
            )
          : validateAssociatedArea?.length > 0
          ? validateAssociatedArea.filter(
              (x) =>
                x.isActive === true ||
                (x.associatedOffices && x.associatedOffices?.length > 1) ||
                (x.associatedOffices &&
                  x.associatedOffices?.length === 1 &&
                  !x.associatedOffices[0]?.officeStatusName.includes("Closed"))
            )
          : [];

      if (validateActiveAssociatedOffice?.length > 0) {
        setAssociatedActive(true);
      } else {
        setAssociatedActive(false);
      }
    }
  }, [dataChart, salesChartData]);

  const deleteMessage = (
    <div className="text-gray-500 font-normal">
      {associatedActive === true
        ? "The releated hierarchies are still active. To deactivate, please modify the hierarchy to remove it's associations and assign new hierarchy."
        : "Are you sure you want to deactivate"}
    </div>
  );

  useEffect(() => {
    if (dataChart && d3Container.current) {
      if (!chartRef.current) {
        chartRef.current = new OrgChart();
      }
      const chart = chartRef.current;

      chart
        .container(d3Container.current)
        .data(dataChart)
        // Chart line color
        .linkUpdate(function () {
          d3.select(this).attr("stroke", "#ced4da").attr("stroke-width", 2);
        })
        .nodeWidth((d) => (d.data.id === 4 ? 350 : 300))
        .nodeHeight((d) => {
          const hasSubtitle =
            d.data.parentId !== "" && d.data.parentId === "1283";

          return [1, 2, 3, 4].includes(d.data.id)
            ? 110
            : hasSubtitle
            ? 120
            : d.data.parentId !== "1283" && d.data.parentId !== ""
            ? 120
            : 120;
        })

        .initialZoom(0.8)
        .childrenMargin((d) => 120)
        .compactMarginBetween((d) => 80)
        .compactMarginPair((d) => 90)
        .siblingsMargin((d) => 80)
        .buttonContent(({ node }) => {
          return ReactDOMServer.renderToString(
            <OHSalesOrgChartButton
              children={node.children}
              directSubordinates={node.data._directSubordinates}
              salesChartData={node.data}
            />
          );
        })
        .nodeContent((node) => {
          return ReactDOMServer.renderToString(
            <OHSalesOrgChartNode
              node={node}
              cardShow={cardShow}
              isClickedEllipsis={isClickedEllipsis}
              officeHierarchyId={officeHierarchyId}
              userPermissions={userPermissions}
              editPermission={editPermission}
              deletePermission={deletePermission}
              salesChartData={salesChartData}
            />
          );
        })
        .nodeUpdate(function (d) {
          //Redirection for territory to area
          d3.select(this)
            .select(".node-card__name")
            .on("click", () => {
              toEmployee(d);
            });
          //For office hierarchy view full page
          d3.select(this)
            .select(".node-card__officeHierarchy")
            .on("click", () => {
              onClickOfficeHierarchyName(d, false);
            });
          // ellipsis
          d3.select(this)
            .select(".node-card__ellipsis")
            .on("click", () => {
              handleShow();
              setOfficeHierarchyId(d.data.officeHierarchyId);
              setSalesChartData(d.data);
            });
          //Edit button
          d3.select(this)
            .select(".edit")
            .on("click", () => {
              setEditState(true);
              setOfficeHierarchyId(officeHierarchyId);
              handleEdit();
              handleClose();
            });
          //Deactivate button
          d3.select(this)
            .select(".deactivate")
            .on("click", () => {
              setOpenModalDelete(true);
              setOfficeHierarchyId([officeHierarchyId]);
              handleClose();
            });
          //Close button
          d3.select(this)
            .select(".close")
            .on("click", () => {
              handleClose();
            });
          //Collapse all
          d3.select(this)
            .select(".collapseAll")
            .on("click", () => {
              chart.collapseAll();
            });
          //Expand all
          d3.select(this)
            .select(".expandAll")
            .on("click", () => {
              chart.expandAll();
            });
          d3.select(this)
            .select(".node-rect")
            .attr("stroke", (d) => (d.data._highlighted ? "#152785" : "none"));
        })
        .compact(compactChart === true ? true : false)
        .layout("left")
        .render();
    }
  }, [dataChart, d3Container.current, cardShow, salesChartData, compactChart]);

  const buttonStyle =
    "ml-2 text-VividBlue border-VividBlue opacity-100 flex items-center place-content-center whitespace-nowrap hover:scale-90 transition duration-500 bg-transparent border-VividBlue shadow-md hover:bg-VividBlue text-VividBlue group relative py-1 px-2 border text-xs font-medium rounded-full hover:text-white focus:outline-none hover:ring-2 focus:ring-offset-2 hover:ring-VividBlue focus:ring-opacity-70";
  const zoomIconStyle =
    "rounded-button h-4 w-4 text-VividBlue  gap-x-1 items-center bg-white opacity-100 hover:scale-90 hover:fill-VividBlue hover:text-white ease select-none focus:outline-none  place-content-center";
  const zoomButtomStyle =
    "ml-2 text-VividBlue border-VividBlue opacity-100 flex items-center place-content-center whitespace-nowrap transition duration-500 bg-transparent border-VividBlue text-VividBlue group relative px-3  text-md font-medium  focus:outline-none";

  const downloadPdf = (chart) => {
    chart.exportImg({
      save: false,
      full: true,
      scale: 15,
      onLoad: async (base64) => {
        var img = new Image();
        img.src = base64;
        img.onload = async function () {
          let { width, height } = img;

          var pdf = new jsPDF({
            orientation: "portrait",
            format: [width, height],
          });

          // Set the display mode upon open of the pdf: Not applicable on web page pdf viewer
          pdf.setDisplayMode("45%", "single", "FullScreen");

          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          // Calculate scaling factors
          const scaleWidth = pdfWidth / width;
          const scaleHeight = pdfHeight / height;

          // Use the higher scaling factor to fit the image within the page
          const scale = Math.max(scaleWidth, scaleHeight);

          // Calculate new dimensions
          const newWidth = width * scale;
          const newHeight = height * scale;

          // Center the image on the page
          const x = (pdfWidth - newWidth) / 2;
          const y = (pdfHeight - newHeight) / 2;

          // Add the image to the PDF
          pdf.addImage(
            img,
            "PNG",
            x, // X-coordinate
            y, // Y-coordinate
            newWidth, // Scaled width
            newHeight, // Scaled height
            null,
            "FAST" // Use high-quality compression
          );

          // Convert to base64 string
          const pdfBase64 = pdf.output("datauristring").split(",")[1];

          // Send to API
          const response = await axios.post(
            `${api_base_url}/OfficeHierarchy/OrgChartDownload`,
            {
              contentType: "application/pdf",
              base64: pdfBase64,
              fileName: "NSAHierarchyOrgChart.pdf",
            },
            { responseType: "blob" }
          );

          // Trigger download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const a = document.createElement("a");
          a.href = url;
          a.download = "SalesOrgChart.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
          setIsDownloading(false);
        };

        // Logging of Error
        img.onerror = (e) => {
          console.log("error", e);
        };

        // Logging of Error
        img.onerror = (e) => {
          console.log("error", e);
        };
      },
    });
  };

  return (
    <>
      <div className="ml-7 border border-VividBlue">
        <div className="text-md text-white flex items-center px-2 py-4">
          <button
            className={buttonStyle}
            onClick={() => {
              chartRef.current?.expandAll().fit();
              setCompactChart(true);
            }}
          >
            <ArrowsPointingOutIcon className="h-4 w-4 mr-2" />
            Expand All
          </button>
          <button
            className={buttonStyle}
            onClick={() => {
              chartRef.current
                ?.collapseAll()
                .setCentered("1283")
                .render()
                .fit();
              setCompactChart(false);
            }}
          >
            <ArrowsPointingInIcon className="h-4 w-4 mr-2" />
            Collapse All
          </button>
          <button
            className={
              isDownloading === true
                ? "ml-2 text-VividBlue border-VividBlue opacity-50 flex items-center place-content-center whitespace-nowrap hover:scale-90 transition duration-500 bg-transparent border-VividBlue shadow-md hover:bg-VividBlue text-VividBlue group relative py-1 px-2 border text-xs font-medium rounded-full hover:text-white focus:outline-none hover:ring-2 focus:ring-offset-2 hover:ring-VividBlue focus:ring-opacity-70"
                : "ml-2 text-VividBlue border-VividBlue opacity-100 flex items-center place-content-center whitespace-nowrap hover:scale-90 transition duration-500 bg-transparent border-VividBlue shadow-md hover:bg-VividBlue text-VividBlue group relative py-1 px-2 border text-xs font-medium rounded-full hover:text-white focus:outline-none hover:ring-2 focus:ring-offset-2 hover:ring-VividBlue focus:ring-opacity-70"
            }
            onClick={() => {
              downloadPdf(chartRef.current);
              setIsDownloading(true);
            }}
            disabled={isDownloading === true}
          >
            <ArrowDownCircleIcon className="h-4 w-4 mr-2" />
            {!isDownloading ? "Download" : "Downloading..."}
          </button>
          <div className="border-l ml-4 flex flex-row">
            <div>
              <button className={zoomButtomStyle}>
                <p>Zoom:</p>
                <div className="m-1">
                  <MinusCircleIcon
                    className={zoomIconStyle}
                    onClick={() => {
                      chartRef.current?.zoomOut();
                    }}
                  />
                </div>

                <div className="m-1">
                  <PlusCircleIcon
                    className={zoomIconStyle}
                    onClick={() => {
                      chartRef.current?.zoomIn();
                    }}
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
        <div style={containerStyles} ref={d3Container} className="relative" />
      </div>
      {openModalDelete && (
        <ConfirmBoxDelete
          ModalTitle="Deactivate Office Hierachy"
          qConfirmation={deleteMessage}
          isOpen={openModalDelete}
          onClose={() => setOpenModalDelete(false)}
          onClickFunction={deactivateHierarchy}
          cancelButtonRef={undefined}
        />
      )}
    </>
  );
};
export default OHSalesOrgChart;
